/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {
  context
} from '../../../objects/context.js';
import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';
import reviewObj from '../../../objects/reviewObj';
import reviewUtil from '../../../objects/reviewUtil';

import optionsUtil from '../../../objects/optionsUtil.js';


class workflowModalModel {

  constructor(params) {
    // Profile
    this.componentName = ko.observable("reviewItemModal");
    this.debug = true;
    this.context = context;
    this.id = ko.observable(this.context.util.guid());
    this.visible = ko.observable(true);

    this.userList = context.userEmployeeList;

    this.addNewUserVisible = ko.observable(false);
    this.roleVisible = ko.observable(false);

    this.reviewId = ko.observable(0);

    this.selectedUser = ko.observable();
    this.WorkflowItem = ko.observable();

    // 3 Modes("New","Current");
    this.mode = ko.observable("New");
    //3 Modes("Edit","Add")
    this.displayMode = ko.observable("Edit");

    this.saveButtonLabel = ko.observable("Add Reviewer");

    this.jobObj = {};

    //UI
    this.enableSaveButton = ko.observable(false);
    this.removeBtnVisible = ko.observable(false);

    //JDMUser Object
    this.name = ko.observable("").extend({
      required: {
        params: true,
        message: 'Name is required.'
      },
      minLength: {
        params: 3,
        message: 'Min length of 3 characters'
      }
    });
    this.email = ko.observable("").extend({
      required: {
        params: true,
        message: 'Email address is required.'
      },
      email: true
    });
    this.title = ko.observable("").extend({
      required: {
        params: true,
        message: 'Title is required.'
      },
      minLength: {
        params: 3,
        message: 'Min length of 3 characters'
      }
    });

    this.userId = ko.observable();
    this.selectedRole = ko.observable(1);
    this.password = ko.observable("");


    this.isValid = ko.validatedObservable({
      email: this.email,
      name: this.name,
      title: this.title
    });

    let self = this;

    context.eventManager.subscribe((reviewObj) => {
      console.log('review-modal:eventManager.subscribe reviewObj: %o', reviewObj);

      this.addNewUserVisible(false);
      this.cleanInputs();
      $('#employeeListSelector option')[0].selected = true;


      if (reviewObj.workflowItem.hasOwnProperty("data")) {
        this.displayMode("Edit");
        this.mode("Current");
        this.WorkflowItem(reviewObj.workflowItem.data);
      } else {
        this.displayMode("Add");
        this.mode("New");
        //this.WorkflowItem(null);
      }

      this.processWorkflowObj(reviewObj);

    }, this, "review-Object-Modal");

    this.init();

  }

  init() {

    let self = this;

    this.selectedUser.subscribe(function (newSelection) {

      console.log('review-modal:selectedUser.subscribe newSelection: %o', newSelection);

      if (typeof newSelection != 'undefined') {
        //Show new useer UI if userid = 0
        if (newSelection.userid === 0) {
          self.addNewUserVisible(true);
          self.mode("New")
          self.setupUI();
        } else {
          self.addNewUserVisible(false);
          self.mode("Current")
          self.setupUI();
        }
      }

    });

  }

  cleanInputs() {
    this.name("");
    this.email("");
    this.title("");
  }

  processWorkflowObj(reviewObj) {
    console.log("review-modal:processWorkflowObj: reviewObj %o".reviewObj);
    $('#reviewItemModal').modal('show');

    this.jobObj = reviewObj.jobObj;

    if (this.displayMode() == "Edit") {
      // Update the select list
      this.setSelectedUser({
        username: reviewObj.workflowItem.data.name()
      });

      this.setupUI();

      console.log("WorkflowItem:");
      console.log(this.WorkflowItem());
    } else {
      this.reviewId(0);
      this.setupUI();
    }

  }


  setupUI() {

    // 3 Modes("New","Current");

    //3 displayModes("Edit","Add")

    if ((this.mode() == "New") && (this.displayMode() === "Add")) {
      console.log("Mode: New Item");
      this.removeBtnVisible(false);
      this.enableSaveButton(false);
      this.saveButtonLabel("Add Reviewer");

    } else if ((this.mode() == "New") && (this.displayMode() === "Edit")) {
      console.log("Mode: Edit New User");
      this.cleanInputs();
      this.addNewUserVisible(true);
      this.removeBtnVisible(true);
      this.saveButtonLabel("Change Reviewer");
    } else if ((this.mode() == "Current") && (this.displayMode() === "Add")) {
      console.log("Mode: Add Item");
      this.removeBtnVisible(false);
      this.enableSaveButton(true);
      this.saveButtonLabel("Add Reviewer");
    } else if ((this.mode() == "Current") && (this.displayMode() === "Edit")) {
      console.log("Mode: Update Item");
      this.addNewUserVisible(false);
      this.removeBtnVisible(true);
      this.enableSaveButton(true);
      this.saveButtonLabel("Change Reviewer");
    }

  }

  setSelectedUser({
    username: userName,
    withDelay = false
  }) {

    console.log("setSelectedUser: " + userName);

    let currentIndex = 1;
    let self = this;

    ko.utils.arrayForEach(this.userList(), function (item) {

      if (typeof userName != 'undefined') {
        if (item.name == userName) {
          //$("#employeeList").val(2);
          $('#employeeListSelector option')[currentIndex].selected = true;
          console.log(self.selectedUser());
          return true;
        }
        currentIndex = currentIndex + 1;
      }
    });

    return false;


    //$("#employeeListSelector").val("2");
    //$('#employeeListSelector option')[2].selected = true;

  }


  updateEmployeeFromUI() {

    console.log(this.selectedUser());

    if (this.selectedUser() != null) {
      this.email(this.selectedUser().email);
      this.name(this.selectedUser().name);
      this.selectedRole(this.selectedUser().role);
      this.title(this.selectedUser().title);
    }

  }

  validate() {
    let errors = ko.validation.group([this.email, this.name]);
    console.log("validate: " + errors());

    if (errors == "") {
      console.log("Vaildation: true");
      this.enableSaveButton(true);
    } else {
      console.log("Vaildation: false");
      this.enableSaveButton(false);
    }

  }

  addUpdateItem(WorkflowItem) {

    let self = this;
    console.log("addUpdateItem");

    console.log(ko.toJSON(WorkflowItem));

    //Save Item
    let reviewUtilObj = new reviewUtil(this.context);
    reviewUtilObj.updateReviewForJob(WorkflowItem).then((response) => {
      self.jobObj.getReviewData(self.context);
    });

    //$('#worflowItemModal').modal('hide');
  }

  deleteMe() {

    let self = this;
    let deleteWorkflowItem = {
      reviewid: this.WorkflowItem().reviewId()
    };

    let reviewUtilObj = new reviewUtil(this.context);
    reviewUtilObj.deleteReviewForJob(deleteWorkflowItem).then((response) => {
      self.jobObj.getReviewData(self.context);
    });

  }

  saveItem({
    userid = this.selectedUser().userid
  }) {
    console.log("saveItem: " + userid);

    if (this.displayMode() == "Add") {
      let TempWorkflowItem = new reviewObj({
        reviewid: null,
        partnerid: this.context.partnerid(),
        subparentid: this.context.subparentid(),
        subid: this.context.subid(),
        jobid: this.jobObj.jobid,
        sort: this.jobObj.getNextReviewSortNumber(),
        guid: this.context.util.guid(),
        jdmUserID: userid,
        role: this.selectedRole(),
        status: "pending...",
        data: "",
        starttime: "",
        endtime: ""
      });

      this.addUpdateItem(TempWorkflowItem);
    } else if (this.displayMode() == "Edit") {
      this.WorkflowItem().jdmUserID(this.selectedUser().userid);
      this.addUpdateItem(this.WorkflowItem);
    }
  }

  closeModal() {
    $('#reviewItemModal').modal("hide");
  }

  addNewUser() {

    console.log("addNewUser:");

    let self = this;
    let oUtil = new optionsUtil(this.context);

    let newTempUser = {
      "userid": null,
      "partnerid": this.context.partnerid(),
      "subparentid": this.context.subparentid(),
      "subid": this.context.subid(),
      "email": this.email(),
      "title": this.title(),
      "valid": 1,
      "password": " ",
      "jdmuserroleid": 1,
      "name": this.name()
    };

    console.log(newTempUser);

    oUtil.updateOptions("internal-users", newTempUser).then(function (result) {
      console.log(result);
      self.displayMode("Add");
      self.saveItem({
        userid: result.userid
      });
      self.geUserData(result);
    });

  }

  geUserData(newUser) {

    console.log("geUserData:");
    console.log(newUser);

    let oUtil = new optionsUtil(this.context);
    let self = this;
    this.selectedUser(newUser);
    //this.userList([]);

    oUtil.getOptions("internal-users").then(function (result) {
      console.log(result);
      self.userList(result);
      //self.selectedUser().userid = newUser.userid;
      //self.displayMode("Add");
      //self.saveItem({userid:newUser.userid})
    });

  }

  updateUserData() {

    return new Promise((resolve, reject) => {

    });

  }
}

export default {
  viewModel: workflowModalModel,
  template: require('!raw-loader!./review-modal.html')
};


// WEBPACK FOOTER //
// ./src/components/review/review-modal/review-modal.js